

import React, { useState, useEffect } from "react";
import "../styles/Navbar.css";
import logo from "../assets/logo.png";
import rightArrow from "../assets/right-arrow.png";
import LanguageSwitcher from "./LanguageSwitcher";
import { useTranslation } from "react-i18next";
import { FaBars, FaTimes } from "react-icons/fa";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLogementDropdownOpen, setIsLogementDropdownOpen] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    document.body.style.overflow = !isMobileMenuOpen ? 'hidden' : 'auto';
  };

  const closeMenu = () => {
    setIsMobileMenuOpen(false);
    document.body.style.overflow = 'auto';
  };

  const handleScrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      const navbar = document.querySelector(".mynavbar");
      let navbarHeight = navbar ? navbar.offsetHeight : 110;

      if (window.innerWidth <= 768) {
        navbarHeight += 10;
      }

      const yOffset = section.getBoundingClientRect().top + window.scrollY - navbarHeight;
      window.scrollTo({ top: yOffset, behavior: "smooth" });

      closeMenu();
      setIsLogementDropdownOpen(false);
    }
  };

  const toggleLogementDropdown = () => {
    setIsLogementDropdownOpen(!isLogementDropdownOpen);
  };

  return (
    <nav className={`mynavbar ${scrolled ? "scrolled" : ""} ${isMobileMenuOpen ? "menu-open" : ""}`}>
      <div className="navbar-container">
        <div className="navbar-logo" onClick={() => handleScrollToSection('home')}>
          <img src={logo} alt={t("logoAltText")} />
        </div>

        <div className="mobile-menu-icon" onClick={toggleMobileMenu}>
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
        </div>

        <div className={`nav-menu-wrapper ${isMobileMenuOpen ? "active" : ""}`}>
          <ul className="nav-ul">
            <li>
              <a href="#home" onClick={() => handleScrollToSection('home')}>{t("home")}</a>
            </li>

            {/* Logement Dropdown */}
            <li className="dropdown">
              <a href="#" onClick={toggleLogementDropdown}>
                {t("Logement")}
              </a>
              {isLogementDropdownOpen && (
                <ul className="dropdown-menu">
                  <li>
                    <a href="#Apartment" className="home-icon" onClick={() => handleScrollToSection('Appartment')}>
                      {t("Appartement")}
                    </a>
                  </li>
                  <li>
                    <a href="#Villa" onClick={() => handleScrollToSection('Villa')}>
                      {t("Villa")}
                    </a>
                  </li>
                  <li>
                    <a href="#Riad" onClick={() => handleScrollToSection('Riad')}>
                      {t("Riad")}
                    </a>
                  </li>
                </ul>
              )}
            </li>

            <li>
              <a href="#about" onClick={() => handleScrollToSection('about')}>{t("ourServices")}</a>
            </li>
            <li>
              <a href="#extra" onClick={() => handleScrollToSection('extra')}>{t("aboutUs")}</a>
            </li>
            <li>
              <a href="#experiences" onClick={() => handleScrollToSection('experiences')}>{t("experiences")}</a>
            </li>
            <li>
              <a href="#vipContact" onClick={() => handleScrollToSection('vipContact')}>{t("vipContact")}</a>
            </li>
            <li className="language-item">
              <span>{t("language")}:</span>
              <LanguageSwitcher />
            </li>
          </ul>
          <div className="nav-button">
            <button onClick={() => handleScrollToSection('reservation-section')}>
              {t("bookNow")}
              <img src={rightArrow} alt={t("arrowAlt")} />
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
